module.exports = __webpack_public_path__ + "img/c4a5716678e7dfce1c8d1d808a70121e.svg";